<template>
  <div>
    <d-card-header class="border-bottom flex-header">
      <h6 class="m-0">Druki umowy</h6>
      <d-button
        v-if="customView"
        @click.prevent="closeForms"
        theme="primary">
        <i class="material-icons">close</i> Zamknij
      </d-button>
      <d-button
        v-if="showNewDocsForm"
        @click.prevent="saveNewDocument"
        class="ml-2"
        theme="success">
        <i class="material-icons">save</i> Zapisz druk umowy
      </d-button>
      <d-button
        v-if="generateContractDocForm"
        @click.prevent="generateGuaranteeDocSubmit"
        class="ml-2"
        theme="success">
        <i class="material-icons">save</i> Generuj druk umowy
      </d-button>
      <d-button
        v-if="generateGuaranteeDocForm"
        @click.prevent="generateContractDocSubmit"
        class="ml-2"
        theme="success">
        <i class="material-icons">save</i> Generuj druk umowy
      </d-button>
    </d-card-header>
    <d-list-group-item v-if="showNewDocsForm">
      <d-form-row>
        <d-col md="3" class="form-group">
          <label>Typ dokumentu</label>
          <d-select
            name="type"
            v-model="document.type"
            @input="lar_errors.clear('type')"
            :class="{'is-invalid' : lar_errors.has('type')}"
            placeholder="">
            <option value="">--Wybierz typ</option>
            <option value="contract">Umowa pożyczki</option>
            <option value="guarantee">Umowa poręczenia</option>
          </d-select>
          <div class="invalid-feedback" v-text="lar_errors.get('type')"></div>
        </d-col>
        <d-col md="3" class="form-group">
          <label>Załaduj plik</label>
          <div class="clearboth"></div>
          <ss-file v-model="document.file"></ss-file>
          <div class="invalid-feedback" v-text="lar_errors.get('file')"></div>
        </d-col>
      </d-form-row>
    </d-list-group-item>
    <d-form v-else-if="generateGuaranteeDocForm">
      <d-list-group-item>
        <h5>Generator umowy poręczyciela</h5>
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Wybór reprezentantów dla spółki</label>
            <d-checkbox
              v-if="representative_options.length > 1"
              :class="{
                'mt-2 small yes-no': true,
                'is-invalid' : lar_errors.has('company_representatives')
              }"
              @change="selectAllRepresentatives"
              v-model="isSelectAllRepresentatives">
              Wybierz wszystkich
            </d-checkbox>
            <d-checkbox
              v-for="(representative, repIndex) in representative_options"
              :key="'representative-' + repIndex"
              :class="{
                'mt-2 small yes-no': true,
                'is-invalid' : lar_errors.has('company_representatives')
              }"
              @change="checkIfAllRepresentativesSelected"
              v-model="representative.selected">
              {{ representative.name }}
            </d-checkbox>
            <div class="invalid-feedback" v-text="lar_errors.get('company_representatives')"></div>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col>
            <div class="form-group">
              <label>Data zawarcia umowy poręczenia</label>
              <ss-date
                type="text"
                name="payment_date"
                v-model="generate_doc.guarantor_contract_date"
                placeholder=""
                :class="{'is-invalid' : lar_errors.has('guarantor_contract_date')}"/>
              <div class="invalid-feedback" v-text="lar_errors.get('guarantor_contract_date')"></div>
            </div>
          </d-col>
          <d-col>
            <div class="form-group">
              <label>Data umowy</label>
              <ss-date
                type="text"
                name="contract_date"
                v-model="generate_doc.contract_date"
                @click="lar_errors.clear('contract_date')"
                :class="{'is-invalid' : lar_errors.has('contract_date')}"
                placeholder=""/>
              <div class="invalid-feedback" v-text="lar_errors.get('contract_date')"></div>
            </div>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col>
            <div class="form-group">
              <label>Imię i nazwisko notariusza</label>
              <d-input
                type="text"
                name="notary_name"
                v-model="generate_doc.notary_name"
                :class="{'is-invalid' : lar_errors.has('notary_name')}"/>
              <div class="invalid-feedback" v-text="lar_errors.get('notary_name')"></div>
            </div>
          </d-col>
          <d-col>
              <div class="form-group">
                <label>Data i numer aktu notarialnego</label>
                <d-input
                  type="text"
                  name="notarial_act_date"
                  v-model="generate_doc.notarial_act_date"
                  :class="{'is-invalid' : lar_errors.has('notarial_act_date')}"/>
                <div class="invalid-feedback" v-text="lar_errors.get('notarial_act_date')"></div>
              </div>
            </d-col>
        </d-form-row>
      </d-list-group-item>
    </d-form>
    <d-form v-else-if="generateContractDocForm">
      <d-list-group-item>
        <h5>Generator umowy pożyczki</h5>
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Wybór reprezentantów dla spółki</label>
              <d-checkbox
                v-if="representative_options.length > 1"
                :class="{
                  'mt-2 small yes-no': true,
                  'is-invalid' : lar_errors.has('company_representatives')
                }"
                @change="selectAllRepresentatives"
                v-model="isSelectAllRepresentatives">
                Wybierz wszystkich
            </d-checkbox>
            <d-checkbox
                v-for="(representative, repIndex) in representative_options"
                :key="'representative-' + repIndex"
                :class="{
                  'mt-2 small yes-no': true,
                  'is-invalid' : lar_errors.has('company_representatives')
                }"
                @change="checkIfAllRepresentativesSelected"
                v-model="representative.selected">
                {{ representative.name }}
            </d-checkbox>
            <div class="invalid-feedback" v-text="lar_errors.get('company_representatives')"></div>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col>
            <div class="form-group">
              <label>Data umowy</label>
              <ss-date
                type="text"
                name="contract_date"
                v-model="generate_doc.contract_date"
                @click="lar_errors.clear('contract_date')"
                :class="{'is-invalid' : lar_errors.has('contract_date')}"
                placeholder=""/>
              <div class="invalid-feedback" v-text="lar_errors.get('contract_date')"></div>
            </div>
          </d-col>
          <d-col>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col>
            <div class="form-group">
              <label>Maksymalna kwota w oświadczeniu o poddaniu się egzekucji</label>
              <ss-price-input
                type="text"
                name="max_contract_amount"
                v-model="generate_doc.max_contract_amount" :class="{'is-invalid' : lar_errors.has('max_contract_amount')}"/>
              <div class="invalid-feedback" v-text="lar_errors.get('max_contract_amount')"></div>
            </div>
          </d-col>
          <d-col>
            <div class="form-group">
              <label>Maksymalna kwota opłaty windykacyjnej(%)</label>
              <ss-price-input
                type="text"
                name="max_recovery_amount"
                v-model="generate_doc.max_recovery_amount" :class="{'is-invalid' : lar_errors.has('max_recovery_amount')}"/>
              <div class="invalid-feedback" v-text="lar_errors.get('max_recovery_amount')"></div>
            </div>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col>
            <div class="form-group">
              <label>Oświadczenie pożyczkodawcy w umowie pkt.2 §6.</label>
              <ss-textarea
                name="company_extra_text"
                v-model="generate_doc.company_extra_text">
              </ss-textarea>
              <div class="invalid-feedback" v-text="lar_errors.get('company_extra_text')"></div>
            </div>
          </d-col>
          <d-col>
            <div class="form-group">
              <label>Zryczałtowana wartość opłaty windykacyjnej(%)</label>
              <ss-price-input
                type="text"
                name="recovery_fee"
                v-model="generate_doc.recovery_fee" :class="{'is-invalid' : lar_errors.has('recovery_fee')}"/>
              <div class="invalid-feedback" v-text="lar_errors.get('recovery_fee')"></div>
            </div>
          </d-col>
        </d-form-row>
        <d-form-row>
          <d-col>
            <div class="form-group">
              <label>Dodatkowe warunki wypowiedzenia umowy
                <d-button
                  theme="success"
                  @click.prevent="addTerminationCondition">
                  <i class="material-icons">add</i>Dodaj
                </d-button>
              </label>

              <div v-for="(condition, index) in generate_doc.contract_termination_conditions" >
                <div class="mb-2 d-flex align-items-center">
                  <span class="mr-2">{{ nextLetter(index)}})</span>
                  <d-input
                    v-model="generate_doc.contract_termination_conditions[index]"
                    :key="index">
                  </d-input>
                  <d-button theme="danger" @click.prevent="removeCondition(index)" class="ml-2">usuń</d-button>
                </div>
              </div>
            </div>
          </d-col>
        </d-form-row>
      </d-list-group-item>
    </d-form>
    <d-form v-else>
      <d-list-group-item>
        <d-form-row>
          <d-col>
            <h5>Umowa pożyczki</h5>
            <template v-if="contract_docs && contract_docs.id">
              <p
                v-if="contract_docs.created_at"
                class="mb-3">
                Umowa dodana dnia <strong>{{ contract_docs.created_at.slice(0, 10) }}</strong>
              </p>
              <d-button
                :class="{ isLoading: exporting_contract_docs  }"
                class=" mb-1"
                theme="success"
                @click.prevent="exportContractDocToPdf(contract_docs)">
                <i class="material-icons">save_alt</i> Pobierz druk umowy
              </d-button>
              <d-button
                @click.prevent="removeDoc(contract_docs, 'umowa pożyczki')"
                class="ml-2 mb-1"
                theme="danger">
                <i class="material-icons">delete</i> Usuń
              </d-button>
            </template>
            <template v-else>
              <p class="text-danger mb-3">brak umowy</p>
              <d-button
                v-if="companyId"
                @click.prevent="showNewContractsDocsForm"
                theme="success">
                <i class="material-icons">add</i> Dodaj druk umowy
              </d-button>
              <ss-popover v-else>
                <d-button
                  theme="success"
                  :disabled="true">
                  <i class="material-icons">add</i> Dodaj druk umowy
                </d-button>
                <template slot="tooltip">
                  Aby wystawić druk umowy musisz mieć wybraną spółkę
                </template>
              </ss-popover>
              <d-button
                v-if="companyId"
                @click.prevent="generateContractDoc"
                theme="primary"
                class="ml-2">
                <i class="material-icons">file_copy</i> Generuj druk umowy
              </d-button>
              <ss-popover v-else>
                <d-button
                  class="ml-2"
                  theme="primary"
                  :disabled="true">
                  <i class="material-icons">file_copy</i> Generuj druk umowy
                </d-button>
                <template slot="tooltip">
                  Aby wygenerować druk umowy musisz mieć wybraną spółkę
                </template>
              </ss-popover>
            </template>
          </d-col>
          <d-col>
            <h5>Umowa poręczenia</h5>
            <template v-if="guarantee_docs && guarantee_docs.id">
              <p
                v-if="guarantee_docs.created_at"
                class="mb-3">
                Umowa dodana dnia <strong>{{ guarantee_docs.created_at.slice(0, 10) }}</strong>
              </p>
              <d-button
                :class="{ isLoading: exporting_guarantee_doc  }"
                class="mb-1"
                theme="success"
                @click.prevent="exportGuaranteeDocToPdf(guarantee_docs)">
                <i class="material-icons">save_alt</i> Pobierz druk umowy
              </d-button>
              <d-button
                @click.prevent="removeDoc(guarantee_docs, 'umowa poręczenia')"
                class="ml-2 mb-1"
                theme="danger">
                <i class="material-icons">delete</i> Usuń
              </d-button>
            </template>
            <template v-else>
              <p class="text-danger mb-3">brak umowy</p>
              <d-button
                v-if="companyId"
                @click.prevent="showNewGuaranteeDocsForm"
                theme="success">
                <i class="material-icons">add</i> Dodaj druk umowy
              </d-button>
              <ss-popover v-else>
                <d-button
                  theme="success"
                  :disabled="true">
                  <i class="material-icons">add</i> Dodaj druk umow
                </d-button>
                <template slot="tooltip">
                  Aby wystawić druk umowy musisz mieć wybraną spółkę
                </template>
              </ss-popover>
              <d-button
                v-if="companyId"
                @click.prevent="generateGuaranteeDoc"
                theme="primary"
                class="ml-2">
                <i class="material-icons">file_copy</i> Generuj druk umowy
              </d-button>
              <ss-popover v-else>
                <d-button
                  class="ml-2"
                  theme="primary"
                  :disabled="true">
                  <i class="material-icons">file_copy</i> Generuj druk umowy
                </d-button>
                <template slot="tooltip">
                  Aby wygenerować druk umowy musisz mieć wybraną spółkę
                </template>
              </ss-popover>
            </template>
          </d-col>
        </d-form-row>
      </d-list-group-item>
    </d-form>
  </div>
</template>

<script>
  import Vue from 'vue';
  import LarErrors from '../../helpers/Errors';
  import SsDate from '../common/SsDate'
  import FileSaver from 'file-saver'
  import SsPriceInput from '../common/SsPriceInput'

  export default {
    name: 'ContractDocs',
    components: {
      LarErrors,
      SsDate,
      SsPriceInput
    },
    props: {
      companyExtraText: {
        default: '',
        type: [String, Number]
      },
      companyId: {
        default: '',
        type: [String, Number]
      },
      contractDate: {
        default: '',
        type: [String, Number]
      },
      contractDocs: {
        default: () => {},
        type: [Object, Array]
      },
      guaranteeDocs: {
        default: () => {},
        type: [Object, Array]
      }
    },
    computed: {
      customView() {
        return this.showNewDocsForm || this.generateDocsForm || this.generateGuaranteeDocForm || this.generateContractDocForm
      }
    },
    watch: {
      contractDocs(to) {
        this.contract_docs = to
      },
      guaranteeDocs(to) {
        this.guarantee_docs = to
      },
      companyExtraText(to){
        this.generate_doc.company_extra_text = to
      },
      contractDate(to){
        this.generate_doc.contract_date = to
      }
    },
    data () {
      return {
        contract_docs: {},
        document: {
          file: null,
          schedule_id: '',
          type: ''
        },
        exporting_contract_docs: false,
        exporting_guarantee_doc: false,
        fetched: false,
        generate_doc: {
          company_extra_text: '',
          contract_date: ''
        },
        generate_doc_submitting: false,
        generateContractDocForm: false,
        generateDocsForm: false,
        generateGuaranteeDocForm: false,
        guarantee_docs: {},
        isSelectAllRepresentatives: false,
        lar_errors: LarErrors,
        new_document_submitting: false,
        representative_options: [],
        showNewDocsForm: false
      }
    },
    mounted () {
      this.document.schedule_id = this.$route.params.schedule_id;
      this.contract_docs = this.contractDocs ? this.contractDocs : this.document;
      this.guarantee_docs = this.guaranteeDocs ? this.guaranteeDocs : this.document;
      this.generate_doc.company_extra_text = this.companyExtraText;
      this.generate_doc.contract_date = this.contractDate;
      this.fetched = true;
      this.getRepresentativesOptions()
    },
    methods: {
      closeForms () {
        this.showNewDocsForm = false;
        this.generateDocsForm = false;
        this.generateGuaranteeDocForm = false;
        this.generateContractDocForm = false;
        this.resetDocument()
      },
      resetDocument () {
        this.isSelectAllRepresentatives = false;
        this.document = {
          schedule_id:  this.$route.params.schedule_id,
          type:       '',
          file:       null
        }
      },
      resetGeneratedDoc () {
        this.representative_options = this.representative_options.map(item => {
          item.selected = false;
          return item;
        });
        this.generate_doc = {
          company_representatives: [],
          schedule_id: this.$route.params.schedule_id,
          type: '',
          contract_number: '',
          guarantor_contract_date: '',
          max_contract_amount: '',
          max_recovery_amount: 10,
          recovery_fee: '',
          contract_termination_conditions: [],
          company_extra_text: this.companyExtraText,
          contract_date: this.contractDate
        }
      },
      addTerminationCondition () {
        this.generate_doc.contract_termination_conditions.push('')
      },
      generateContractDoc () {
        this.resetGeneratedDoc();
        this.generate_doc.type = 'contract';
        this.generateContractDocForm = true;
      },
      generateGuaranteeDoc () {
        this.resetGeneratedDoc();
        this.generate_doc.type = 'guarantee';
        this.generateGuaranteeDocForm = true;
      },
      showNewGuaranteeDocsForm () {
        this.document.type = 'guarantee';
        this.showNewDocsForm = true;
      },
      submitGeneratedDoc () {
        this.generate_doc.company_representatives = this.representative_options.filter(item => item.selected).map(item => item.id);
        this.generate_doc_submitting = true;
        this.generate_doc.contract_termination_conditions = this.generate_doc.contract_termination_conditions.filter((el) => el.length > 0);
          axios.post('api/contract-docs/generate-doc', this.generate_doc).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Dokument został wygenerowany.',
            showConfirmButton: true,
          }).then(() => {
            this.fetchData(() => this.closeForms())
          });
          this.generate_doc_submitting = false;
        }).catch((error) =>{
          Vue.swal({
              type: 'error',
              title: error.response.data.message,
              html: Vue.transformErrorsToHtml(error.response.data.errors),
              showConfirmButton: true,
          });
          this.generate_doc_submitting = false;
          LarErrors.record(error.response.data.errors);
        })
      },
      generateGuaranteeDocSubmit () {
        this.submitGeneratedDoc();
      },
      generateContractDocSubmit () {
        this.submitGeneratedDoc ();
      },
      showNewContractsDocsForm () {
        this.document.type = 'contract';
        this.showNewDocsForm = true;
      },
      removeCondition (index) {
        this.generate_doc.contract_termination_conditions.splice(index, 1);
        this.$forceUpdate();
      },
      fetchData (callback) {
        axios.post('api/schedules/get-schedule', {id: this.$route.params.schedule_id}).then(response => {
          this.guarantee_docs = response.data.guarantee_doc;
          this.contract_docs = response.data.contract_doc;
          if (callback){
            callback()
          }
        }).catch(errors => {
          console.log(errors);
        })
      },
      getRepresentativesOptions () {
        axios.post('api/get-company-representatives').then(response => {
          this.representative_options = response.data
        }).catch(errors => {
          console.log(errors);
        })
      },
      saveNewDocument () {
        var data = new FormData();
        Vue.appendFormdata(data, this.document);

        this.new_document_submitting = true;
        axios.post('api/contract-docs/upload-doc ', data).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Dokument został dodany.',
            showConfirmButton: true,
          }).then(() => {
            this.fetchData(() => this.closeForms())
          });
          this.new_document_submitting = false;
        }).catch((error) =>{
          Vue.swal({
            type: 'error',
            title: error.response.data.message,
            html: Vue.transformErrorsToHtml(error.response.data.errors),
            showConfirmButton: true,
          });
          this.new_document_submitting = false;
          LarErrors.record(error.response.data.errors)
        })
      },
      exportContractDocToPdf (doc) {
        this.exporting_contract_docs = true;
        this.exportFile(
          'api/contract-docs/download-doc',
          doc.filename,
          doc.id,
          () => {
            this.exporting_contract_docs = false;
          }
        )
      },
      exportGuaranteeDocToPdf (doc) {
          this.exporting_guarantee_doc = true;
          this.exportFile(
            'api/contract-docs/download-doc',
            doc.filename,
            doc.id,
            () => {
              this.exporting_guarantee_doc = false;
            }
          )
      },
      exportFile (endpoint, filename, id, callback) {
        axios.post(endpoint, { id }, { responseType: 'blob' }).then(response => {
          let blob = new File(
            [response.data],
            filename,
            { type: 'application/' + filename.substr(filename.lastIndexOf(".") + 1) }
          );
          FileSaver.saveAs(blob);
          callback()
        }).catch(error=>{
          callback()
        })
      },
      nextLetter (index) {
        let letter = 'h';
        for (let i = 0;i < index; i++) {
          letter = String.fromCharCode(letter.charCodeAt(letter.length - 1) + 1)
        }
        return letter
      },
      removeDoc (document, filename) {
        Vue.swal({
          title: 'Uwaga',
          html: 'Czy potwierdzasz usunięcie dokumentu ' + filename + '?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Tak',
          cancelButtonText: 'Nie',
          buttonsStyling: true
        }).then((logout) => {
          if(logout.value){
            axios.post('api/contract-docs/remove-doc ', {
              id: document.id
            }).then(response => {
                Vue.swal({
                  type: 'success',
                  title: 'Dokument został usunięty.',
                  showConfirmButton: true,
                }).then(() => {
                  this.fetchData(() => this.closeForms())
                });
            }).catch((errors) =>{
              console.log(errors);
            })
          }
        }).catch((errors) =>{
          console.log(errors);
        })
      },
      selectAllRepresentatives (newValue) {
        this.$nextTick(() => {
          this.representative_options = this.representative_options.map(item => {
            item.selected = newValue;

            return item;
          });
        });
      },
      checkIfAllRepresentativesSelected () {
        this.$nextTick(() => {
          let isAllSelected = this.representative_options.every(item => item.selected === true);

          if (isAllSelected) {
            Vue.set(this, 'isSelectAllRepresentatives', true);
          } else {
            Vue.set(this, 'isSelectAllRepresentatives', false);
          }
        });
      }
    }
  }
</script>
